// Skip redirect for Women's Day page
if (!window.location.pathname.includes('/pages/women-day')) {
  fetch("https://ipapi.co/json/")
    .then((o) => o.json())
    .then((o) => {
      if (o.country_code !== "IN") {
        // Keep same path, query params, and hash
        const currentPath = window.location.pathname + window.location.search + window.location.hash;

        // Redirect only by changing domain
        window.location.href = "https://us.sadhanatablet.com" + currentPath;
      }
    })
    .catch((o) => console.log(o));
}